/**
 * Description: Add Free Plant Labels (5pcs)s when choosing 1-month or 3-months option
 * Updated at: 2022/01/14
 */

var product_url = '';
var product_url_array = [];
var variant_id_current = '';
var price = '';
var cruleid = '';
var step_1_display_float_type = '';
var step_2_display_float_type = '';
var step_3_display_float_type = '';
var planId = '';
var selectizeControl;

// add Free Plant Labels (5pcs) when choose 1-month or 3-months option
// var extra_gift = '\nA Free Plant';
var extra_gift = '\n';

$(document).ready(function() {
  // Init
  getFirstType();
  getSecondType();
  getThirdType();
  getProductUrl();
  calculatePriceForThirdStep();
  calculatePrice();
  if ($('.sumoSelect').length > 0) {
    const $select = $('.sumoSelect').selectize({
      plugins: ["remove_button"],
      placeholder: 'SELECT MONTHS...',
      hideSelected: false,
      maxItems: 0,
      onChange: function(values) {
        const control = this;
        const $items = $(control.$control).find('.item');
        const maxVisible = 2;

        calculatePrice();
      },
      onItemAdd: function(value) {
        // keep dropdown open for toggling
        this.refreshOptions(false);
      },
      onItemRemove: function(value) {
        this.refreshOptions(false);
      }
    });
    const control = $select[0].selectize
    selectizeControl = control;
    control.$dropdown.on('mousedown', '[data-value]', e => e.preventDefault()); // stop default
    // control.$dropdown.on('click', '[data-value]', function () {
    //     console.log($(this))
    //     const v = $(this).attr('data-value');
    //     if (control.items.indexOf(v) !== -1) control.removeItem(v);
    //     else control.addItem(v);
    //     control.refreshOptions(false);
    //     control.open();
    // });
  }
  // updateStampedReview();

  // Scroll if url contains hashtag
  scrollToDivIdWithHashtag('#block__claypots-step-2', 'block__claypots-step-2');

  $('.step-1-display-float').click(function() {
    $('.step-1-display-float').each(function() {
      $(this).removeClass('active');
    });
    $(this).addClass('active');
    scrollToDivId('block__claypots-step-2');
    getFirstType();
    getSecondType();
    getThirdType();
    getProductUrl();
    calculatePriceForThirdStep();
    calculatePrice();
    // updateStampedReview();
  });

  $('.step-2-display-float').click(function() {
    if (!checkSelectedFirstStep()) {
      scrollToDivId('block__claypots-step-2');
      alert('Please select step 1!');
      return false;
    }
    $('.step-2-display-float').each(function() {
      $(this).removeClass('active');
    });
    $(this).addClass('active');
    scrollToDivId('block__claypots-step-3');
    getSecondType();
    getProductUrl();
    calculatePriceForThirdStep();
    calculatePrice();
    updateBanner()
    // updateStampedReview();
  });

  $('.step-3-display-float').click(function() {
    if (!checkSelectedFirstStep()) {
      scrollToDivId('block__claypots-step-2');
      alert('Please select step 1!');
      return false;
    }
    if (!checkSelectedSecondStep()) {
      scrollToDivId('block__claypots-step-2');
      alert('Please select step 2!');
      return false;
    }
    $('.step-3-display-float').each(function() {
      $(this).removeClass('active');
    });
    $(this).addClass('active');

    // if enable extra gift
    // updateBanner()

    // if enable extra gift
    if ($('.block__claypots-step-3-2').length) {
      if ($('.block__claypots-step-3-2 .step-3-2').is(":visible")) {
        scrollToDivId('block__claypots-step-3-2', 80);
      } else {
        // Open heat pack
        scrollToDivId('block__claypots-step-3-1', detectMobile() ? 20 : 0);
        // scrollToDivId('block__claypots-step-4', detectMobile() ? 20 : 0);
        // End open heat pack
      }
    } else {
      // Open heat pack
      scrollToDivId('block__claypots-step-3-1');
      // scrollToDivId('block__claypots-step-4');
      // End open heat pack
    }

    getThirdType();
    getProductUrl();
    calculatePrice();
  });

  $('.change-quantity').click(function() {
    let old_quantity = parseInt($('input[name=quantity]').val());
    if ($(this).data('func') == 'minus') {
      if (old_quantity <= 0) {
        $('input[name=quantity]').val(0);
      } else {
        $('input[name=quantity]').val(old_quantity - 1);
      }
    } else {
      $('input[name=quantity]').val(old_quantity + 1);
    }

    // Open heat pack
    calculatePriceHeatPack();
    // End open heat pack

    calculatePrice();
  });

  $('input[name=quantity]').keyup(function(event) {
    let quantity = $(this).val();
    if (!quantity || quantity < 0) {
      quantity = 0;
    }

    let price_el = $('.step-3-1-price span.current_price span.money');
    let price = parseFloat(price_el.text().replace('$', ''));
    $('.step-3-1-qty-right span').text('$' + abridgedNumber(quantity * price));
    $('.block__claypots-step-final table tr:nth-of-type(3) td:nth-of-type(2)').html('$' + abridgedNumber(quantity * price));
    let totalSelected = selectizeControl.getValue()
    if (totalSelected.length >Number(quantity) ) {
      const tmpSelect = totalSelected.slice(0,Number(quantity) )
      selectizeControl.setValue(tmpSelect)
    }
    selectizeControl.setMaxItems(Number(quantity))
    selectizeControl.refreshValidityState()
    calculatePrice();
  });

  // if enable extra gift
  if ($('.block__claypots-step-3-2').length) {
    $('.block__claypots-step-3-2 .step-3-2 .item').click(function() {
      $('.block__claypots-step-3-2 .step-3-2 .item').each(function() {
        $(this).css('filter', 'brightness(70%)');
      });
      $(this).addClass('active');
      $(this).css('filter', 'none');

      // extra_gift = '\nA Free Plant + Extra Gift: ' + $(this).attr('data-product-name');
      extra_gift = '\nExtra Gift: ' + $(this).attr('data-product-name');

      // Open heat pack
      scrollToDivId('block__claypots-step-3-1', detectMobile() ? 20 : 0);
      // scrollToDivId('block__claypots-step-4', detectMobile() ? 20 : 0);
      // End open heat pack
    });
  }

  // Open heat pack
  // select options heat pack
  $('.block__claypots-step-3-1 .swatch_options label').click(function() {
    $('.block__claypots-step-3-1 .step-2-img').hide();

    let data_id = $(this).parent().attr('data-id');
    let available_variant = $('.block__claypots-step-3-1 .step-2-img[data-id=' + data_id + ']');

    available_variant.show();
    $('.block__claypots-step-3-1 span.current_price span.money').text(available_variant.attr('data-price'));
    $('input[name=heat-pack-id]').val(data_id);

    calculatePriceHeatPack();

    calculatePrice();
  })
  // End open heat pack

  $(".add-sub-gift").click(function(e) {
    const self = this;
    e.preventDefault();
    if (!checkSelectedFirstStep()) {
      scrollToDivId('block__claypots-step-2');
      alert('Please select step 1!');
      return false;
    }
    if (!checkSelectedSecondStep()) {
      scrollToDivId('block__claypots-step-2');
      alert('Please select step 2!');
      return false;
    }
    if (!checkSelectedThirdStep()) {
      scrollToDivId('block__claypots-step-3');
      alert('Please select step 3!');
      return false;
    }

    let note = $('#subsgift_message').val();
    if (extra_gift) {
      note += extra_gift;
    }

    if ($('.step-3-1 input[name=quantity]').val() > 0) {
      let items = [];
      let selectedMonth =  $('select[name="heat_month"]').val()
      let monthNote = '';
      let boughtHeatPack = Number($('input[name="old_heat_pack_in_cart"]').val());
      let heatPackQuantity = Number($('input[name=quantity]').val());
      let totalHeatPack = boughtHeatPack + heatPackQuantity;
      if (totalHeatPack > 0) {
        note += '\nTotal Heat Pack: ' + totalHeatPack
      }
      if (selectedMonth.length > 0) {
        monthNote += '\nHeat Pack Months: ';
        monthNote += selectedMonth.join(' - ')
        note += monthNote
      }
      items.push({
        "form_type": "product",
        "quantity": $('.step-3-1 input[name=quantity]').val(),
        "id": $('input[name=heat-pack-id]').val(),
        "note": note
      });
      items.push({
        "form_type": "product",
        "quantity": 1,
        "id": variant_id_current,
        "note": note,
        "selling_plan": planId,
        "purchase_type": "autodeliver"
      })

      $.post('/cart/add.js', {
        items: items,
        note: note
      }).done(function() {
        if ($(self).hasClass('go-to-checkout')) {
          window.location.href = '/checkout';
        } else {
          window.location.href = '/cart';
        }
      }).fail(function(error) {
        window.location.href = '/cart';
      });
    } else {
      jQuery.ajax({
        type: "POST",
        dataType: 'json',
        url: '/cart/add.js',
        async: true,
        data: {
          "form_type": "product",
          "quantity": 1,
          "id": variant_id_current,
          "note": note,
          "selling_plan": planId,
          "purchase_type": "autodeliver"
        },
        success: function(cdata) {
          if ($(self).hasClass('go-to-checkout')) {
            window.location.href = '/checkout';
          } else {
            window.location.href = '/cart';
          }
        },
        error: function() {
          window.location.href = '/cart';
        }
      });
    }
  });
});

function scrollToDivId(div_id, custom_height = 0) {
  if (detectMobile()) {
    let height_scroll = $('body').hasClass('promo_banner-show') ? 70 : 105;
    $('html, body').animate({
      scrollTop: $('#' + div_id).offset().top - height_scroll - custom_height
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $('#' + div_id).offset().top - 60 - custom_height
    }, 1000);
  }
}

function scrollToDivIdWithHashtag(hashtag, div_id) {
  if (window.location.hash == hashtag) {
    scrollToDivId(div_id);
  }
}

function detectMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

function getFirstType() {
  step_1_display_float_type = $('.step-1-display-float.active').attr('data-type');
}

function getSecondType() {
  step_2_display_float_type = $('.step-2-display-float.active').attr('data-type');
}

function getThirdType() {
  step_3_display_float_type = $('.step-3-display-float.active').attr('data-type');
  cruleid = $('.step-3-display-float.active').attr('data-cruleid');
}

function checkSelectedFirstStep() {
  let bool = false;
  $('.step-1-display-float').each(function() {
    if ($(this).hasClass('active')) {
      bool = true;
      return false;
    }
  });
  return bool;
}

function checkSelectedSecondStep() {
  let bool = false;
  $('.step-2-display-float').each(function() {
    if ($(this).hasClass('active')) {
      bool = true;
      return false;
    }
  });
  return bool;
}

function checkSelectedThirdStep() {
  let bool = false;
  $('.step-3-display-float').each(function() {
    if ($(this).hasClass('active')) {
      bool = true;
      return false;
    }
  });
  return bool;
}

function getProductUrl() {
  let shippingFee = 6.99
  if (step_1_display_float_type == 'for-myself') {
    switch (step_2_display_float_type) {
      case '1-succulent-1-clay-pot-month-auto-renew':
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = '1-succulent-1-clay-pot-month-subscription-boxes';
            break;
          case '3-months':
            product_url = '1-succulent-1-clay-pot-month-3-month-subscription';
            break;
          case '6-months':
            product_url = '1-succulent-1-clay-pot-month-6-month-subscription';
            break;
          case '12-months':
            product_url = '1-succulent-1-clay-pot-month-12-month-subscription';
            break;
        }
        product_url_array = [
          '1-succulent-1-clay-pot-month-subscription-boxes',
          '1-succulent-1-clay-pot-month-3-month-subscription',
          '1-succulent-1-clay-pot-month-6-month-subscription',
          '1-succulent-1-clay-pot-month-12-month-subscription'
        ];
        break;
      case '2-succulents-2-clay-pots-month-auto-renew':
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = '2-succulents-2-clay-pots-month-subscription-boxes';
            break;
          case '3-months':
            product_url = '2-succulents-2-clay-pots-month-3-month-subscription';
            break;
          case '6-months':
            product_url = '2-succulents-2-clay-pots-month-6-month-subscription';
            break;
          case '12-months':
            product_url = '2-succulents-2-clay-pots-month-12-month-subscription';
            break;
        }
        product_url_array = [
          '2-succulents-2-clay-pots-month-subscription-boxes',
          '2-succulents-2-clay-pots-month-3-month-subscription',
          '2-succulents-2-clay-pots-month-6-month-subscription',
          '2-succulents-2-clay-pots-month-12-month-subscription'
        ];
        break;
      case '3-succulents-3-clay-pots-month-auto-renew':
        shippingFee = 7.99
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = '3-succulents-3-clay-pots-month-subscription-boxes';
            break;
          case '3-months':
            product_url = '3-succulents-3-clay-pots-month-3-month-subscription';
            break;
          case '6-months':
            product_url = '3-succulents-3-clay-pots-month-6-month-subscription';
            break;
          case '12-months':
            product_url = '3-succulents-3-clay-pots-month-12-month-subscription';
            break;
        }
        product_url_array = [
          '3-succulents-3-clay-pots-month-subscription-boxes',
          '3-succulents-3-clay-pots-month-3-month-subscription',
          '3-succulents-3-clay-pots-month-6-month-subscription',
          '3-succulents-3-clay-pots-month-12-month-subscription'
        ];
        break;
      case '4-succulents-4-clay-pots-month-auto-renew':
        shippingFee = 8.99
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = '4-succulents-4-clay-pots-month-subscription-boxes';
            break;
          case '3-months':
            product_url = '4-succulents-4-clay-pots-month-3-month-subscription';
            break;
          case '6-months':
            product_url = '4-succulents-4-clay-pots-month-6-month-subscription';
            break;
          case '12-months':
            product_url = '4-succulents-4-clay-pots-month-12-month-subscription';
            break;
        }
        product_url_array = [
          '4-succulents-4-clay-pots-month-subscription-boxes',
          '4-succulents-4-clay-pots-month-3-month-subscription',
          '4-succulents-4-clay-pots-month-6-month-subscription',
          '4-succulents-4-clay-pots-month-12-month-subscription'
        ];
        break;
      case '1-airplant-1-accessory-month-auto-renew':
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = '1-airplant-1-accessory-month-subscription-boxes';
            break;
          case '3-months':
            product_url = '1-airplant-1-accessory-month-3-month-subscription';
            break;
          case '6-months':
            product_url = '1-airplant-1-accessory-month-6-month-subscription';
            break;
          case '12-months':
            product_url = '1-airplant-1-accessory-month-12-month-subscription';
            break;
        }
        product_url_array = [
          '1-airplant-1-accessory-month-subscription-boxes',
          '1-airplant-1-accessory-month-3-month-subscription',
          '1-airplant-1-accessory-month-6-month-subscription',
          '1-airplant-1-accessory-month-12-month-subscription'
        ];
        break;
      default: {
        product_url = '';
        product_url_array = [];
      }
    }
    $('#banner-claypots-step-final .shipping-fee').text(shippingFee)
  }
  if (step_1_display_float_type == 'its-a-gift') {
    switch (step_2_display_float_type) {
      case '1-succulent-1-clay-pot-month-auto-renew':
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = 'gift-1-succulent-1-clay-pot-month-subscription-boxes';
            break;
          case '3-months':
            product_url = 'gift-1-succulent-1-clay-pot-month-3-month-subscription';
            break;
          case '6-months':
            product_url = 'gift-1-succulent-1-clay-pot-month-6-month-subscription';
            break;
          case '12-months':
            product_url = 'gift-1-succulent-1-clay-pot-month-12-month-subscription';
            break;
        }
        product_url_array = [
          'gift-1-succulent-1-clay-pot-month-subscription-boxes',
          'gift-1-succulent-1-clay-pot-month-3-month-subscription',
          'gift-1-succulent-1-clay-pot-month-6-month-subscription',
          'gift-1-succulent-1-clay-pot-month-12-month-subscription'
        ];
        break;
      case '2-succulents-2-clay-pots-month-auto-renew':
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = 'gift-2-succulents-2-clay-pots-month-subscription-boxes';
            break;
          case '3-months':
            product_url = 'gift-2-succulents-2-clay-pots-month-3-month-subscription';
            break;
          case '6-months':
            product_url = 'gift-2-succulents-2-clay-pots-month-6-month-subscription';
            break;
          case '12-months':
            product_url = 'gift-2-succulents-2-clay-pots-month-12-month-subscription';
            break;
        }
        product_url_array = [
          'gift-2-succulents-2-clay-pots-month-subscription-boxes',
          'gift-2-succulents-2-clay-pots-month-3-month-subscription',
          'gift-2-succulents-2-clay-pots-month-6-month-subscription',
          'gift-2-succulents-2-clay-pots-month-12-month-subscription'
        ];
        break;
      case '3-succulents-3-clay-pots-month-auto-renew':
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = 'gift-3-succulents-3-clay-pots-month-subscription-boxes';
            break;
          case '3-months':
            product_url = 'gift-3-succulents-3-clay-pots-month-3-month-subscription';
            break;
          case '6-months':
            product_url = 'gift-3-succulents-3-clay-pots-month-6-month-subscription';
            break;
          case '12-months':
            product_url = 'gift-3-succulents-3-clay-pots-month-12-month-subscription';
            break;
        }
        product_url_array = [
          'gift-3-succulents-3-clay-pots-month-subscription-boxes',
          'gift-3-succulents-3-clay-pots-month-3-month-subscription',
          'gift-3-succulents-3-clay-pots-month-6-month-subscription',
          'gift-3-succulents-3-clay-pots-month-12-month-subscription'
        ];
        break;
      case '4-succulents-4-clay-pots-month-auto-renew':
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = 'gift-4-succulents-4-clay-pots-month-subscription-boxes';
            break;
          case '3-months':
            product_url = 'gift-4-succulents-4-clay-pots-month-3-month-subscription';
            break;
          case '6-months':
            product_url = 'gift-4-succulents-4-clay-pots-month-6-month-subscription';
            break;
          case '12-months':
            product_url = 'gift-4-succulents-4-clay-pots-month-12-month-subscription';
            break;
        }
        product_url_array = [
          'gift-4-succulents-4-clay-pots-month-subscription-boxes',
          'gift-4-succulents-4-clay-pots-month-3-month-subscription',
          'gift-4-succulents-4-clay-pots-month-6-month-subscription',
          'gift-4-succulents-4-clay-pots-month-12-month-subscription'
        ];
        break;
      case '1-airplant-1-accessory-month-auto-renew':
        switch (step_3_display_float_type) {
          case '1-month':
            product_url = 'gift-1-airplant-1-accessory-month-subscription-boxes';
            break;
          case '3-months':
            product_url = 'gift-1-airplant-1-accessory-month-3-month-subscription';
            break;
          case '6-months':
            product_url = 'gift-1-airplant-1-accessory-month-6-month-subscription';
            break;
          case '12-months':
            product_url = 'gift-1-airplant-1-accessory-month-12-month-subscription';
            break;
        }
        product_url_array = [
          'gift-1-airplant-1-accessory-month-subscription-boxes',
          'gift-1-airplant-1-accessory-month-3-month-subscription',
          'gift-1-airplant-1-accessory-month-6-month-subscription',
          'gift-1-airplant-1-accessory-month-12-month-subscription'
        ];
        break;
      default: {
        product_url = '';
        product_url_array = [];
      }
    }
  }
}

function calculatePrice() {
  if (product_url) {
    jQuery.ajax({
      dataType: 'json',
      url: 'https://succulentsbox.com/products/' + product_url + '.js',
      async: true,
      success: function(data) {
        // update variant id
        variant_id_current = data.variants[0].id;
        product_id_current = data.id;
        planId = data.variants[0].selling_plan_allocations[0].selling_plan_id
        let prefixTitleProduct = ''
        prefixTitleProduct = (step_1_display_float_type == 'for-myself' ? '' : 'GIFT - ');
        // if (subscribeMode == 'grower-pot') {
        //     prefixTitleProduct += 'GROWER POT / '
        // } else {
        //     prefixTitleProduct += 'CLAY POT / '
        // }
        $('.block__claypots-step-final table tr:nth-of-type(1) td:nth-of-type(2)').html(prefixTitleProduct + $('.step-2-display-float.active').attr('data-title') + '/ MONTH');
        let subscription_length = $('.step-3-display-float.active').attr('data-title');
        if (step_1_display_float_type == 'for-myself') {
          $('.block__claypots-step-final table tr:nth-of-type(2) td:nth-of-type(2)').html(subscription_length + ' (AUTO-RENEWED)');
        } else {
          $('.block__claypots-step-final table tr:nth-of-type(2) td:nth-of-type(2)').html(subscription_length + ' (ONE TIME CHARGE)');
        }

        // Open heat pack
        let heatpack_price = $('.block__claypots-step-final table tr:nth-of-type(3) td:nth-of-type(2)').text().replace('$', '');
        heatpack_price = heatpack_price ? parseFloat(heatpack_price) : 0;
        if (heatpack_price > 0) {
          var selectedMonth = $('select[name="heat_month"]').val()
          quantity = $('input[name=quantity]').val();
          var text = quantity + ' MONTHS'
          if (selectedMonth.length > 0) {
            text += ' ';
            var subText = selectedMonth.join(' - ')
            text += '(' + subText + ')'
          }
          $('.block__claypots-step-final table tr:nth-of-type(3) td:nth-of-type(2)').html(text)

        } else {
          $('.block__claypots-step-final table tr:nth-of-type(3) td:nth-of-type(2)').html('')
        }
        // End open heat pack
        // Open heat pack
        $('.block__claypots-step-final table tr:nth-of-type(4) td:nth-of-type(2)').html("$" + abridgedNumber(heatpack_price + parseFloat(data.variants[0].price / 100)));
        // $('.block__claypots-step-final table tr:nth-of-type(3) td:nth-of-type(2)').html("$" + abridgedNumber(parseFloat(data.variants[0].price / 100)));
        // End open heat pack
      }
    });
  }
}

function calculatePriceForThirdStep() {
  if (product_url_array.length) {
    product_url_array.forEach(function(item, index) {
      jQuery.ajax({
        dataType: 'json',
        url: 'https://succulentsbox.com/products/' + item + '.js',
        async: true,
        success: function(data) {
          $('.step-3-' + index + ' .step-3-price').text('$' + data.variants[0].price / 100);
          if (data.variants[0].compare_at_price != '') {
            let price = parseFloat(data.variants[0].price / 100);
            let compare_at_price = parseFloat(data.variants[0].compare_at_price/100);
            if (price < compare_at_price) {
              let salePercent = 100 - (price / compare_at_price) * 100;
              $('.step-3-' + index + ' .step-3-sale').html('<span class="step-3-base-price">$' + data.variants[0].compare_at_price/100 +  " </span>(-" + Math.floor(salePercent) + "%)");
              $('.step-3-' + index + ' .step-3-sale').css("visibility", "visible");
            } else {
              $('.step-3-' + index + ' .step-3-sale').text("");
              $('.step-3-' + index + ' .step-3-sale').css("visibility", "hidden");
            }
          } else {
            $('.step-3-' + index + ' .step-3-sale').text("");
            $('.step-3-' + index + ' .step-3-sale').css("visibility", "hidden");
          }
        }
      });
    });
  } else {
    $('.step-3-price').text('');
    $('.step-3-sale').text('');
    $('.step-3-sale').css("visibility", "hidden");
  }
}

// Open heat pack
function calculatePriceHeatPack() {
  quantity = $('input[name=quantity]').val();
  let price_el = $('.step-3-1-price span.current_price span.money');
  let price = price_el.text();
  price = parseFloat(price.replace('$', ''));
  $('.step-3-1-qty-right span').text('$' + abridgedNumber(quantity * price));
  $('.block__claypots-step-final table tr:nth-of-type(3) td:nth-of-type(2)').html('$' + abridgedNumber(quantity * price));
  let totalSelected = selectizeControl.getValue()
  if (totalSelected.length >Number(quantity) ) {
    const tmpSelect = totalSelected.slice(0,Number(quantity) )
    selectizeControl.setValue(tmpSelect)
  }
  selectizeControl.setMaxItems(Number(quantity))
  selectizeControl.refreshValidityState()
}
// End open heat pack

function abridgedNumber(number) {
  return (Math.round((number + Number.EPSILON) * 100) / 100);
}

function updateStampedReview() {
  const elActive = $('.step-2-display-float.active')
  if (elActive.length > 0) {
    const productId = elActive.data('id');
    // const productName = elActive.attr('data-name');
    // const handle = elActive.attr('data-sku')
    let widget = $('#stamped-main-widget')
    widget.attr('data-product-id', productId)
    // widget.attr('data-name', productName)
    // widget.attr('data-product-sku', handle)
    setTimeout(function () {
      if (StampedFn) {
        StampedFn.reloadUGC();
      }
    }, 2000)
  }
}

function triggerBannerButtonClick(step1DataType) {
  scrollToDivId('block__claypots-step-2', detectMobile() ? 35 : 0);
  $(`.step-1-display-float[data-type="${step1DataType}"]`).trigger('click')
  if (step1DataType == 'its-a-gift') {
    $('.block__claypots-step-4').removeClass('hidden')
  } else {
    $('.block__claypots-step-4').addClass('hidden')
  }
}

function updateBanner() {
  // if enable extra gift
  if ($('.block__claypots-step-3-2').length) {
    let data_type = $('.step-3-display-float.active').attr('data-type');
    if (data_type == '12-months' || data_type == '6-months') {
      $('.block__claypots-step-3-2 .step-3-2 .step-3-2-month-3-month-subs').hide(0);
      $('.block__claypots-step-3-2 .step-3-2 .step-3-2-month-3-month-subs').addClass('hidden');
      $('.block__claypots-step-3-2 .step-3-2 .plants-2-over-step-3-2-month-3-month-subs').addClass('hidden');
      if (['1-airplant-1-accessory-month-auto-renew', '1-succulent-1-clay-pot-month-auto-renew'].includes($('.step-2-display-float.active').data('type'))) {
        $('.block__claypots-step-3-2').removeClass('has-4-column')
        $('.block__claypots-step-3-2 .item.only-over-2-plants').addClass('hidden')
        $('.block__claypots-step-3-2 .step-3-2 .plant-1-step-3-2-6-months-12-months-subs').show(500);
        $('.block__claypots-step-3-2 .step-3-2 .plant-1-step-3-2-6-months-12-months-subs').removeClass('hidden');
        $('.block__claypots-step-3-2 .step-3-2 .step-3-2-6-months-12-months-subs').hide(0);
        $('.block__claypots-step-3-2 .step-3-2 .step-3-2-6-months-12-months-subs').addClass('hidden');
      } else {
        $('.block__claypots-step-3-2').addClass('has-4-column')
        $('.block__claypots-step-3-2 .item.only-over-2-plants').removeClass('hidden')
        $('.block__claypots-step-3-2 .step-3-2 .step-3-2-6-months-12-months-subs').show(500);
        $('.block__claypots-step-3-2 .step-3-2 .step-3-2-6-months-12-months-subs').removeClass('hidden');
        $('.block__claypots-step-3-2 .step-3-2 .plant-1-step-3-2-6-months-12-months-subs').hide(0);
        $('.block__claypots-step-3-2 .step-3-2 .plant-1-step-3-2-6-months-12-months-subs').addClass('hidden');
      }

      $('.block__claypots-step-3-2 .step-3-2 .step-3-2-items').removeClass('hidden');
      $('.block__claypots-step-3-2 .step-3-2').addClass('with-border-conner');
      let active_item = $('.block__claypots-step-3-2 .step-3-2 .item.active');
      if (active_item) {
        if (data_type == '6-months' && active_item.hasClass('only-12-month')) {
          // reset extra gift not allowed
          extra_gift = '';
          active_item.removeClass('active')
          $('.block__claypots-step-3-2 .step-3-2 .item').css('filter', 'none');
        } else {
          // update extra gift
          // extra_gift = '\nA Free Plant + Extra Gift: ' + active_item.attr('data-product-name');
          extra_gift = '\nExtra Gift: ' + active_item.attr('data-product-name');
        }
      }
    } else {
      $('.block__claypots-step-3-2 .step-3-2 .plant-1-step-3-2-6-months-12-months-subs').hide(0);
      $('.block__claypots-step-3-2 .step-3-2 .step-3-2-6-months-12-months-subs').hide(0);
      $('.block__claypots-step-3-2 .step-3-2 .plant-1-step-3-2-6-months-12-months-subs').addClass('hidden');
      $('.block__claypots-step-3-2 .step-3-2 .step-3-2-6-months-12-months-subs').addClass('hidden');
      $('.block__claypots-step-3-2 .step-3-2 .step-3-2-items').addClass('hidden');

      if (['1-airplant-1-accessory-month-auto-renew', '1-succulent-1-clay-pot-month-auto-renew'].includes($('.step-2-display-float.active').data('type'))) {
        $('.block__claypots-step-3-2 .step-3-2 .step-3-2-month-3-month-subs').show(500);
        $('.block__claypots-step-3-2 .step-3-2 .step-3-2-month-3-month-subs').removeClass('hidden');
        $('.block__claypots-step-3-2 .step-3-2 .plants-2-over-step-3-2-month-3-month-subs').addClass('hidden');
      } else {
        $('.block__claypots-step-3-2 .step-3-2 .plants-2-over-step-3-2-month-3-month-subs').show(500);
        $('.block__claypots-step-3-2 .step-3-2 .plants-2-over-step-3-2-month-3-month-subs').removeClass('hidden');
        $('.block__claypots-step-3-2 .step-3-2 .step-3-2-month-3-month-subs').addClass('hidden');
      }

      $('.block__claypots-step-3-2 .step-3-2').removeClass('with-border-conner');

      // add Free Plant Labels (5pcs) when choose 1-month or 3-months option
      if (data_type == '3-months') {
        extra_gift = '\nA Free Plant';
      } else if (data_type == '1-month') {
        extra_gift = '\n';
      } else {
        // clear extra gift
        extra_gift = '';
      }
    }
  }
}